
class SelectorVariants extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form')
        this.addEventListener('change', this.onVariantChange);
    }
    onVariantChange(event) {
        this.currentVariant = event.target.value
        this.updateMasterId()
        this.updateURL();
        this.renderProductInfo();
    }
    updateMasterId() {
        this.form.querySelector('.add-to-cart').setAttribute('data-variant-id', this.currentVariant)
    }
    updateURL(){
        const url = new URL(window.location);
        url.searchParams.set('variant', this.currentVariant);
        window.history.pushState(null, '', url.toString());
    }

    async renderProductInfo(){
        try{
            const response = await (await fetch(window.location.href + '&section_id=product-template')).text()
            const responseMarkup = new DOMParser().parseFromString(response, 'text/html')
            document.querySelector('[data-price-container]').innerHTML = responseMarkup.querySelector('[data-price-container]').innerHTML

            /* NDK: also update hidden price container used by ATC button sync */
            var hiddenPrice = document.getElementById('price-product-template')
            var newHiddenPrice = responseMarkup.getElementById('price-product-template')
            if (hiddenPrice && newHiddenPrice) {
                hiddenPrice.innerHTML = newHiddenPrice.innerHTML
            }

            document.dispatchEvent(new CustomEvent('changed_variant', {
                    bubbles: true,
                    detail: {
                        section: this.form
                    }
                }));

        }catch (error) {
            console.error(error)
        }
    }

}
customElements.define('selector-variants', SelectorVariants);


class DiscountCoupon{
    constructor() {
        const templateEl = document.querySelector("#couponMarkupPatterns")
        if (!templateEl?.content?.children?.length) return
        const [price, savingCoupon, savingBadge] = templateEl.content.children
        this.markupPatterns = {
            price: price,
            savingCoupon: savingCoupon,
            savingBadge: savingBadge
        }

        this.discountCode = this.getCookie("discount_code")

        if(!this.discountCode){
            this.discountCode = localStorage.getItem("coupon")
        }

        if(!this.discountCode) return;

        localStorage.setItem("coupon", this.discountCode)

        this.getDiscount()
    }

    /**
     * _parseCartDiscount – extract discountData from a cart object.
     * Returns the discountData object or null if it cannot be determined.
     */
    _parseCartDiscount(cart) {
        if (!cart.cart_level_discount_applications?.length) return null
        const disc = cart.cart_level_discount_applications[0]
        const discAmount = disc.total_allocated_amount || 0
        const itemsSubtotal = cart.items.reduce((s, i) => s + (i.final_line_price || 0), 0)
        if (itemsSubtotal <= 0 || discAmount <= 0) return null

        const ratio = discAmount / itemsSubtotal
        const cleanPercent = Math.round(ratio * 100)
        const isPercentage = Math.abs(ratio - cleanPercent / 100) < 0.002

        return {
            canUse: "true",
            items: { __typename: "AllDiscountItems" },
            value: isPercentage
                ? { __typename: "DiscountPercentage", percentage: cleanPercent / 100 }
                : { __typename: "DiscountAmount", amount: { amount: discAmount / 100 } }
        }
    }

    /**
     * _probeDiscountWithTempItem – When the cart is empty Shopify cannot
     * report discount amounts. This method silently adds a temporary item,
     * reads the discount, then removes the item. The user never sees
     * anything because the cart drawer is not open during this flow.
     */
    async _probeDiscountWithTempItem() {
        try {
            // 1. Find a valid variant ID from the current page or from /products.json
            let variantId = null

            // Try current PDP first (fastest, no network call)
            const variantEl = document.querySelector('[data-variant-id]')
            if (variantEl) {
                variantId = variantEl.getAttribute('data-variant-id')
            }

            // Fallback: fetch first available product
            if (!variantId) {
                const prodRes = await fetch('/products.json?limit=1')
                const prodData = await prodRes.json()
                if (prodData.products?.[0]?.variants?.[0]?.id) {
                    variantId = prodData.products[0].variants[0].id
                }
            }

            if (!variantId) return null

            // 2. Add 1 unit silently
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 1 })
            })

            // 3. Re-apply discount code (Shopify sometimes drops it on empty→non-empty transition)
            await fetch('/discount/' + encodeURIComponent(this.discountCode), {
                method: 'GET', redirect: 'manual'
            }).catch(() => {})
            await new Promise(r => setTimeout(r, 300))

            // 4. Read cart with discount applied
            const cart = await (await fetch('/cart.js')).json()
            const result = this._parseCartDiscount(cart)

            // 5. Remove the temporary item.
            // NDK 2026-08: decrementar por line key en vez de "variant qty:0" — si el
            // usuario añadió ese mismo variant en paralelo, qty:0 borraba SU línea.
            const tempLine = (cart.items || []).find(i => String(i.variant_id) === String(variantId))
            if (tempLine) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: tempLine.key, quantity: Math.max(0, tempLine.quantity - 1) })
                })
            }

            return result
        } catch (e) {
            return null
        }
    }

    async getDiscount(){
        try{
            // NDK 2026-08: rediseño conservador.
            // Antes: re-aplicaba /discount/ POR CADA código en CADA page load y luego
            // reducía la cookie al PRIMER código aplicable (rompía multi-código FLASH+INVIO).
            // Ahora: lee el carrito primero, solo aplica los códigos que a la sesión le
            // faltan, y persiste TODOS los aplicables (CSV), filtrando junk (TBN_*).
            const rawCode = this.discountCode
            const codes = rawCode.split(',')
                .map(function(c) { return c.trim().toUpperCase(); })
                .filter((c, i, arr) => c.length > 0 && !this._isJunk(c) && arr.indexOf(c) === i)

            let cart = await (await fetch('/cart.js')).json()
            const sessionCodes = (cart.discount_codes || []).map(function(dc) { return (dc.code || '').toUpperCase(); })
            const missing = codes.filter(function(c) { return sessionCodes.indexOf(c) === -1; })

            if (missing.length > 0) {
                for (var ci = 0; ci < missing.length; ci++) {
                    await fetch('/discount/' + encodeURIComponent(missing[ci]), { method: 'GET', redirect: 'manual' }).catch(function(){})
                }
                await new Promise(function(r) { setTimeout(r, 200); })
                cart = await (await fetch('/cart.js')).json()
            }

            // All applicable codes from Shopify (junk-filtered)
            const applicableCodes = (cart.discount_codes || [])
                .filter(dc => dc.code && dc.applicable !== false && !this._isJunk(dc.code))
                .map(function(dc) { return dc.code.toUpperCase(); })

            // If no applicable code found, clean up and stop
            if (applicableCodes.length === 0) {
                localStorage.removeItem("coupon")
                localStorage.removeItem("coupon_data")
                localStorage.removeItem("discount_code")
                localStorage.removeItem("sc:discount.code")
                document.cookie = 'discount_code=; path=/; max-age=0'
                this.discountCode = null
                this.discountData = null
                return
            }

            // PDP painter usa el primero (igual que antes); la cookie conserva TODOS
            this.discountCode = applicableCodes[0]
            const csv = applicableCodes.join(',')
            localStorage.setItem("coupon", csv)
            document.cookie = 'discount_code=' + encodeURIComponent(csv) + '; path=/; max-age=2592000'

            let parsed = this._parseCartDiscount(cart)

            // Cart is empty or discount not calculable — try temp-item probe
            if (!parsed && cart.item_count === 0) {
                parsed = await this._probeDiscountWithTempItem()
            }

            if (parsed) {
                this.discountData = parsed
                localStorage.setItem("coupon_data", JSON.stringify(this.discountData))
                this.initProductsHandler()
                return
            }

            // Still nothing — try localStorage cache as last resort
            const cached = localStorage.getItem("coupon_data")
            if (cached) {
                try {
                    this.discountData = JSON.parse(cached)
                    this.initProductsHandler()
                    return
                } catch(e) {}
            }
            localStorage.setItem("coupon", "")

        }catch (error) {
        }
    }

    initProductsHandler(){
        const { items: {__typename: discountItemsType, products} } = this.discountData
        const productsSelector = discountItemsType === "AllDiscountItems" ? '[data-product-handle]'
            : products.nodes.map(({handle}) => `[data-product-handle=${handle}]`).join(',')

        this.productWrappers = document.querySelectorAll(productsSelector)

        if(!this.productWrappers) return

        this.updatePrices(this.productWrappers)
        this.updateVariantCards()

        if (!this._handlerSetup) {
            this._handlerSetup = true
            this.productsHandler()
        }
    }

    productsHandler(){
        document.addEventListener('changed_variant', ({detail: {section}}) =>{
            this.updatePrices(section.querySelectorAll(`[data-price-container]`))
        })
    }

    updatePrices(productsWrappers){
        const { value: {__typename: discountType} } = this.discountData
        const discountValue = discountType === "DiscountPercentage" ? this.discountData.value.percentage
            : this.discountData.value.amount.amount * 100

        productsWrappers.forEach(wrapper => {
            wrapper.querySelectorAll("[data-price]").forEach(priceWrapper => {
                if (priceWrapper.dataset.couponApplied === this.discountCode) return
                
                if (!priceWrapper.dataset.originalHtml) {
                    priceWrapper.dataset.originalHtml = priceWrapper.innerHTML
                }
                
                const { priceFormat, price, comparePrice } = priceWrapper.dataset
                const [withCurrency, pattern, haveSaving, insetFormat, savingFormat] = priceFormat?.split("|")
                if(!price) return

                let updatePrice = discountType === "DiscountPercentage" ?
                    price * (1 - discountValue) :
                    price - discountValue

                if(savingFormat === "discount_amount"){
                    updatePrice = (comparePrice ? comparePrice : price) - updatePrice
                }

                const formatted_price = window.Shopify.formatMoney(updatePrice, withCurrency)
                if(insetFormat === "append"){
                    priceWrapper.innerHTML += this.buildPrice(formatted_price, pattern)
                } else if(insetFormat === "prepend"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern) + priceWrapper.innerHTML
                } else if(insetFormat === "insert"){
                    priceWrapper.innerHTML = this.buildPrice(formatted_price, pattern)
                }

                if(haveSaving){
                    const savingPercent = (((comparePrice ? comparePrice : price) - updatePrice) / (comparePrice ? comparePrice : price) * 100).toFixed(0)
                    priceWrapper.innerHTML += this.buildPrice(savingPercent, savingFormat)
                }
                
                priceWrapper.dataset.couponApplied = this.discountCode
            })
        })
    }

    // v44: Update variant cards with coupon info
    // Shows coupon badge, updates daily cost, shows sale-strike price
    updateVariantCards() {
        if (!this.discountData) return

        const { value: { __typename: discountType } } = this.discountData
        const discountValue = discountType === "DiscountPercentage"
            ? this.discountData.value.percentage
            : this.discountData.value.amount.amount * 100

        const discountPercent = discountType === "DiscountPercentage"
            ? Math.round(discountValue * 100)
            : null

        document.querySelectorAll('.selector-variant__wrapper > label[data-variant-id]').forEach(label => {
            if (label.dataset.couponCardApplied === this.discountCode) return
            label.dataset.couponCardApplied = this.discountCode

            const variantPrice = parseInt(label.dataset.variantPrice) || 0
            const variantComparePrice = parseInt(label.dataset.variantComparePrice) || 0
            const variantDays = parseInt(label.dataset.variantDays) || 0

            // Calculate coupon price
            let couponPrice
            if (discountType === "DiscountPercentage") {
                couponPrice = variantPrice * (1 - discountValue)
            } else {
                couponPrice = variantPrice - discountValue
            }
            couponPrice = Math.round(couponPrice)

            // Calculate total discount percentage (from original/compare price to coupon price)
            const originalPrice = variantComparePrice > 0 ? variantComparePrice : variantPrice
            const totalDiscountPercent = Math.round(((originalPrice - couponPrice) / originalPrice) * 100)

            // --- Show coupon badge ---
            const couponBadge = label.querySelector('.variant__coupon-badge')
            if (couponBadge) {
                couponBadge.textContent = `CUPÓN -${totalDiscountPercent}%`
                couponBadge.style.display = ''
            }

            // --- Show sale-strike (current price becomes strikethrough) ---
            const saleStrike = label.querySelector('.variant__price-sale-strike')
            if (saleStrike) {
                saleStrike.style.display = ''
            }

            // --- Update main price to coupon price ---
            const priceMain = label.querySelector('.variant__price-main')
            if (priceMain) {
                const formatted = window.Shopify.formatMoney(couponPrice, '')
                const parts = formatted.replace('€', '').trim().split(',')
                const intPart = parts[0] || ''
                const centsPart = parts[1] || '00'
                priceMain.innerHTML = `<span class="variant__price-int">${intPart}</span><span class="variant__price-cents">,${centsPart}€</span>`
            }

            // --- Update daily cost ---
            const dailyCostEl = label.querySelector('.variant__daily-cost')
            if (dailyCostEl && variantDays > 0) {
                if (!dailyCostEl.dataset.originalText) {
                    dailyCostEl.dataset.originalText = dailyCostEl.textContent
                }
                const dailyCoupon = Math.round(couponPrice / variantDays)
                dailyCostEl.textContent = `SALE A ${window.Shopify.formatMoney(dailyCoupon, '')} / DÍA`
            }
        })
    }

    revertPrices() {
        document.querySelectorAll('[data-coupon-applied]').forEach(el => {
            if (el.dataset.originalHtml) {
                el.innerHTML = el.dataset.originalHtml
                delete el.dataset.originalHtml
            }
            delete el.dataset.couponApplied
        })

        document.querySelectorAll('.selector-variant__wrapper > label[data-coupon-card-applied]').forEach(label => {
            delete label.dataset.couponCardApplied

            const couponBadge = label.querySelector('.variant__coupon-badge')
            if (couponBadge) {
                couponBadge.style.display = 'none'
                couponBadge.textContent = ''
            }

            const saleStrike = label.querySelector('.variant__price-sale-strike')
            if (saleStrike) {
                saleStrike.style.display = 'none'
            }

            // Restore original main price from data attributes
            const variantPrice = parseInt(label.dataset.variantPrice) || 0
            const priceMain = label.querySelector('.variant__price-main')
            if (priceMain && variantPrice) {
                const formatted = window.Shopify.formatMoney(variantPrice, '')
                const parts = formatted.replace('€', '').trim().split(',')
                const intPart = parts[0] || ''
                const centsPart = parts[1] || '00'
                priceMain.innerHTML = `<span class="variant__price-int">${intPart}</span><span class="variant__price-cents">,${centsPart}€</span>`
            }

            const dailyCostEl = label.querySelector('.variant__daily-cost')
            if (dailyCostEl && dailyCostEl.dataset.originalText) {
                dailyCostEl.textContent = dailyCostEl.dataset.originalText
                delete dailyCostEl.dataset.originalText
            }
        })

        this.discountData = null
        this.discountCode = null
    }

    async applyNow(code) {
        code = String(code || '').trim().toUpperCase()
        if (!code || this._isJunk(code)) return
        this.discountCode = code
        // NDK 2026-08: merge en la CSV existente en vez de sobreescribir — antes esta
        // escritura pisaba los códigos multi aplicados por el usuario (vía Klaviyo, etc.)
        const existingRaw = this.getCookie("discount_code") || (function(){ try { return localStorage.getItem("coupon") || ''; } catch(e) { return ''; } })()
        const merged = existingRaw.split(',')
            .map(function(c) { return c.trim().toUpperCase(); })
            .filter((c, i, arr) => c.length > 0 && !this._isJunk(c) && arr.indexOf(c) === i)
        if (merged.indexOf(code) === -1) merged.push(code)
        const csv = merged.join(',')
        document.cookie = 'discount_code=' + encodeURIComponent(csv) + '; path=/; max-age=2592000'
        localStorage.setItem("coupon", csv)
        
        try {
            await fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'manual' }).catch(() => {})
            await new Promise(r => setTimeout(r, 200))
            
            const cart = await (await fetch('/cart.js')).json()
            
            let parsed = this._parseCartDiscount(cart)

            // Cart is empty — probe with temp item to discover the discount
            if (!parsed && cart.item_count === 0) {
                parsed = await this._probeDiscountWithTempItem()
            }

            if (!parsed) {
                // Last resort: cached data from a previous session
                const cached = localStorage.getItem("coupon_data")
                if (cached) {
                    try { parsed = JSON.parse(cached) } catch(e) {}
                }
            }
            
            if (parsed) {
                this.discountData = parsed
                localStorage.setItem("coupon_data", JSON.stringify(this.discountData))
                this.initProductsHandler()
            }
        } catch(e) {}
    }

    getCookie(name) {
        const match = document.cookie.match(new RegExp('(^|;)\\s*' + name + '=([^;]*)'))
        return match ? decodeURIComponent(match[2]) : null
    }

    // NDK 2026-08: mismo criterio que _isJunkCode de utcart-v2.js — mantener en sync
    _isJunk(code) {
        if (!code) return true
        const u = String(code).toUpperCase()
        return u === 'TBN_REMOVE_DISCOUNT_CODES' || u.indexOf('TBN_REMOVE') === 0
    }

    buildPrice(money, type){
        switch (type){
            case "separated": {
                const [intPrice, fractionalPrice] = money.split(",")
                return this.markupPatterns.price.outerHTML.replace('{intPrice}', intPrice)
                    .replace('{fractionalPrice}', fractionalPrice)
                break
            }
            case "inline": {
                return money
                break
            }
            case "covered-inline": {
                return `<span>${money}</span>`
                break
            }
            case "coupon": {
                return this.markupPatterns.savingCoupon.outerHTML.replace('{percent}', money)
                break
            }
            case "badge": {
                return this.markupPatterns.savingBadge.outerHTML.replace('{percent}', money)
                break
            }
        }
    }

}
window.discountCoupon = new DiscountCoupon()

// === Klaviyo popup discount auto-apply ===
window.addEventListener("klaviyoForms", function(e) {
    if (e.detail.type === 'close' || e.detail.type === 'submit') {
        let foundCode = ''
        
        // Strategy 1: Find a button inside the Klaviyo form whose text looks like a coupon code
        // Coupon codes are short (3-15 chars), uppercase alphanumeric, inside a button
        // Exclude known non-code buttons (close, submit/CTA which are longer phrases)
        var klavForm = document.querySelector('.klaviyo-form, [data-testid*="klaviyo-form"]')
        if (klavForm) {
            klavForm.querySelectorAll('button').forEach(function(btn) {
                var text = btn.textContent.trim()
                // Skip close buttons and long CTA buttons (> 15 chars are phrases, not codes)
                if (btn.classList.contains('klaviyo-close-form')) return
                if (text.length > 15) return
                // Match coupon code pattern: 3-15 alphanumeric chars (with optional hyphens/underscores)
                if (/^[A-Z0-9][A-Z0-9_-]{1,14}$/i.test(text) && !foundCode) {
                    foundCode = text.toUpperCase()
                }
            })
        }

        // Strategy 2 fallback: check for a dedicated coupon element with data attribute
        if (!foundCode) {
            document.querySelectorAll('[data-coupon], [data-testid*="coupon"]').forEach(function(el) {
                var text = el.textContent.trim()
                if (/^[A-Z0-9_-]{3,15}$/i.test(text) && !foundCode) {
                    foundCode = text.toUpperCase()
                }
            })
        }
        
        if (foundCode && window.discountCoupon) {
            window.discountCoupon.applyNow(foundCode)
        }
    }
})
